import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';

import StaffDesignationRevisionModal from './StaffDesignationRevisionModal';
import StaffDesignationRevisionApprovesModal from './StaffDesignationRevisionApprovesModal';

class StaffDesignationApprovesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      staff_id: this.props.staff_id,
      designation_id: null,
      date_start: '',
      modal_props: false,
      data_modal_approves: {},
    };

    //bind específico
    this.showModal = this.showModal.bind(this);
    this.showModalApproves = this.showModalApproves.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      staff_designations_finalized: newProps.staff_designations_finalized,
    });
  }
  showModal (value) {
    this.setState({
      data_modal: value,
      modal_props: true,
    });
  }
  showModalApproves (value) {
    this.setState({
      data_modal_approves: value,
      modal_approves: true,
    });
  }

  modalPropsOff () {
    this.setState({ modal_props: false});
    this.setState({ modal_approves: false});
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Lista de Revisão de Designação</h3>
  <hr/>
  {(this.state.staff_designations_finalized === null || typeof this.state.staff_designations_finalized === 'undefined') ?  <div><small><em>Nenhuma designação finalizada cadastrada.</em></small><hr/></div>
  :

  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">Número da Revisão</th>
          <th className="text-center">Data de Finalização da Revisão</th>
          <th className="text-center">Gestores Responsáveis</th>
          <th className="text-center">Aprovações</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_designations_finalized).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_designations_finalized[k].number_str}</td>
              <td className="text-center">{self.state.staff_designations_finalized[k].date_str}</td>
              <td className="text-center">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => self.showModal(self.state.staff_designations_finalized[k].staff_revision_designation_responsibles)}
                  disabled={self.state.staff_designations_finalized[k].finalized !== 1 ?
                  "disabled"
                  : ""
                  }
                >
                  <i className="fa fa-fw fa-pencil"></i>
                </button>
              </td>
              <td className="text-center">
                <button
                  className="btn btn-sm btn-primary"
                  value={self.state.staff_designations_finalized[k]}
                  id={self.state.staff_designations_finalized[k].id}
                  onClick={() => self.showModalApproves(self.state.staff_designations_finalized[k])}
                  disabled={self.state.staff_designations_finalized[k].finalized !== 1 ?
                  "disabled"
                  : ""
                  }
                >
                  <i className="fa fa-fw fa-pencil"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <StaffDesignationRevisionModal handleAlert={self.props.handleAlert} modalPropsOff={self.modalPropsOff} modal={self.state.modal_props} designation_responsibles={self.state.data_modal} refreshData={self.props.refreshData} />

  <StaffDesignationRevisionApprovesModal handleAlert={self.props.handleAlert} modalPropsOff={self.modalPropsOff} modal={self.state.modal_approves} responsibles_to_approve={self.state.data_modal_approves.responsibles_to_approve} staff_to_approve={self.state.data_modal_approves.staff_to_approve} refreshData={self.props.refreshData} />
</div>
    );
  }
}

export default StaffDesignationApprovesTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffDesignationApprovesTab.js